import { Events, EventType } from '../api/types'

export const getDisplayEvent = (value: EventType | string | undefined): string => {
  const s = value === Events.SIGNED_UP ? 'New Referal' : value
  return s ? s.split('_').join(' ') : ''
}
